<template>
  <v-dialog v-model="dialog" persistent width="1600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-btn icon @click.native="close()"> <v-icon>close</v-icon> </v-btn>Ver
        información del interinato
      </v-card-title>

      <!-- Cuerpo del formulario -->

      <v-card>
        <v-card-text>
          <v-container grid-list-md class="formato">
            <v-layout wrap>
              <v-flex xs12>
                <strong>Tipo de movilidad: </strong>  {{ this.form.tipo_movimiento }}
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <strong>Dependencia: </strong> {{ this.datos.nombre_unidad }}
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <strong>Número de ítem: </strong> {{ this.datos.nro_item }}
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <strong>Puesto: </strong> {{ this.datos.puesto }}
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <strong>Cargo: </strong> {{ this.datos.cargo }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <v-card-actions>
        <small class="error--text text-required"></small>
        <v-spacer></v-spacer>
        <v-btn @click.native="close()">
          <v-icon>cancel</v-icon> {{ "cerrar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      url: "vMovimientosMovilidads",
      graphql: true,
      // Cabecera de la tabla

      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        id_persona
        nro_doc
        fecha_desde
        fecha_hasta
        fecha_registro
        cargo
        puesto
        unidad
        nro_item
        tipo_movimiento
        nro_memorandum
        id_tipo_justificacion
        id_puesto
        id_unidad
        id_cargo
      `,
      initData: [],
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [],
      form: {},

      vMovimientosMovilidads: [],
      dialog: false,
      form: {},
      datos: {},
      valid: false,
      loading: false,
    };
  },
  async mounted() {
    this.$bus.$on("openDialogVerInformacionInterinato", async (item) => {
      this.form = item;
      await this.cargarDatos();
      this.dialog = true;
    });
  },
  methods: {
    async cargarDatos() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta: "SELECT * FROM movilidad.v_interinatos where id_movilidad=(${parseInt(
                  this.form.id
                )})"){
                  respuesta
                }
              }
            `,
        });

        respuesta = respuesta.runQuery.respuesta[0];
        this.datos = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogVerInformacionInterinato");
      this.dialog = false;
    },
  },
};
</script>

<style>
.formato {
  color: rgb(5, 5, 12);
  white-space: pre-line;
  word-wrap: break-word;

  font-size: 1.1em;
  margin: 0.7em 0.7em 0.7em 0.7em;
  padding: 0em 0em 0em 0em;

}
</style>


// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/VerInformacionInterinato.vue